import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { WebsocketEmitters } from '@common/app/socket';
import { socket } from '@common/socket/socket';
import classNames from 'classnames';

import { useGetUserFriendsGroupQuery } from '@/api/queries/group';
import { defaultToastConfig } from '@/common/config/toast';
import TabsBody from '@/components/Friends/TabsBody/TabsBody';
import { PageBackground } from '@/components/ui/Backgrounds/PageBackground/PageBackground';
import { showToast } from '@/components/ui/Notification/SwipeableToastNotification';
import { useAppSelector } from '@/redux/store';

import backgroundPng from '/img/bg/friends-page.png';
import backgroundWebp from '/img/bg/friends-page.webp';
import remove from '/img/icons/dropDownList-more/remove.svg';
import rename from '/img/icons/dropDownList-more/rename.svg';

const Friends: React.FC = () => {
  const { isSuccess } = useGetUserFriendsGroupQuery({ page: 1 });
  const groupFriends = useAppSelector((state) => state.groupFriends.group);

  const message = (
    customText: string,
    socketData: string,
    imgSrc: string,
  ): void => {
    showToast(
      `${customText} "${socketData}"`,
      { img: imgSrc },
      defaultToastConfig,
    );
  };

  useEffect(() => {
    const handleGroupNameChange = (data: string): void =>
      message('New group name:', data, rename);
    const handleUserRemoved = (data: string): void =>
      message('User removed from group:', data, remove);

    socket.on(WebsocketEmitters.CHANGE_GROUP_NAME, handleGroupNameChange);
    socket.on(WebsocketEmitters.USER_REMOVED_FROM_GROUP, handleUserRemoved);

    return (): void => {
      socket.off(WebsocketEmitters.CHANGE_GROUP_NAME, handleGroupNameChange);
      socket.off(WebsocketEmitters.USER_REMOVED_FROM_GROUP, handleUserRemoved);
    };
  }, []);

  return (
    <main
      className={classNames(
        'page !mb-0 flex flex-col',
        !groupFriends && 'justify-end',
      )}
    >
      <Helmet>
        <title>Friends</title>
      </Helmet>
      <PageBackground
        variant="page"
        backgroundImage={{ png: backgroundPng, webp: backgroundWebp }}
      />
      <div className="tabs tabs--sticky" style={{ padding: '0 1rem' }}>
        <TabsBody isRequestEnd={isSuccess} />
      </div>
    </main>
  );
};

export default Friends;
